module.exports = __webpack_public_path__ + "static/media/logo.2d7ef83c.png";